const localStorageKeysConstants = Object.freeze({
  ACCOUNTING_AGENT_BANNER_DISMISSED: 'accounting_agent_banner_dismissed',
  CLOSED_BALANCE_AUTH: 'closed_balance_auth',
  COMPANY_ID: 'company',
  COMPLETE_KYC_BANKING_CARD_DISMISSED: 'complete_kyc_banking_card_dismissed',
  // The Expenses export wizard's own saved column default -- sibling of EXPORT_COLUMNS below,
  // kept as its own key (not a shared one) because the two wizards have independent column
  // contracts (expense-export-columns.json vs export-columns.json) and a selection saved for one
  // must never be read back as a selection for the other.
  EXPENSE_EXPORT_COLUMNS: 'expense_export_columns',
  EXPENSE_SUGGESTIONS: 'expense_suggestions',
  // The export wizard's saved column default (plan ready-to-use-accounting-exports.md §5 story
  // 7b) -- one key, scoped by company id the way FULL_WIDTH_AGENT_CHAT_SESSION is, because
  // `changeCompany()` can fire without the user picking a company (app-desktop/CLAUDE.md, "API
  // Layer"). Holds within a session only: `clearUserStoredData` removes it with every other key.
  EXPORT_COLUMNS: 'export_columns',
  FULL_WIDTH_AGENT_CHAT_SESSION: 'full_width_agent_chat_session',
  NAVIGATION_COLLAPSED: 'navigation_collapsed',
  // Stashed by ExportDownloadPage before an unauthenticated requester is sent to log in, so
  // the login flow can return them to the export link instead of the overview page (plan
  // ready-to-use-accounting-exports.md §5 story 3b).
  POST_LOGIN_REDIRECT: 'post_login_redirect',
  PHONE_NUMBER: 'f7a42fe7211f98ac7a60a285ac3a9e87',
  SDI_BANNER_DISMISSED: 'sdi_banner_dismissed',
  SESSION_ID: 'session_id',
  SHOW_WELCOME: 'showWelcome',
  TOKEN: 'token',
  TWO_FA_STARTED: 'c035cae691c14072bcbe1053538a9ad9',
  SCA_HEADER_TYPE: 'headerType',
  SCA_SESSION_KEY: 'session_key'
});
export {localStorageKeysConstants};
